import {Injectable} from '@angular/core';
import {EntityClass} from '../../entity.class';
import {entityDecorator} from '../../entity.decorator';

@Injectable()
@entityDecorator({
  url: 'api/mentalseal/v1/admin/department/change',
  name: 'admin',
  idName: 'adminId',
  protobufJSON: require('assets/protobuf/ownerManage/ownerManage.json'),
  protobufModule: 'Admin'
})
export class ChangeDptService extends EntityClass {

}



// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/services/entity-base/entity-service/ownerRoleManage/change-department.service.ts